import { render, staticRenderFns } from "./MewBadge.vue?vue&type=template&id=3e0e119c"
import script from "./MewBadge.vue?vue&type=script&lang=js"
export * from "./MewBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports